import React, { useState } from 'react'
import { Col, Panel, Row, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import IncomeRecordForm from './IncomeRecordForm'
import IncomeRecordTable from './IncomeRecordTable'
import {
  saveInstallmentIncome,
  deleteInstallmentIncome,
  downloadRecieptVoucherFile,
} from '../../redux/actions/incomeAndExpense'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import {
  sessionGetItemJSON,
  sessionGetItemStr,
  sessionRemoveItem,
} from '../../utils/sessionHelpers'
import { DEFAULT_ERR_MSG, DELETE_SUCCESS_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { previewFile } from '../../utils/fileUtil'
import IncomeRecordView from './IncomeRecordView'

export default function IncomeRecordWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isEnableEdit, setIsEnableEdit] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const voucherInfo = sessionGetItemJSON('voucherInfo')
  const isViewOnly = !!sessionGetItemStr('isViewOnly')

  let history = useHistory()

  const handleCallDelete = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await deleteInstallmentIncome(voucherInfo?.id)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
        })
        setIsShowConfirmDelete(false)
        sessionRemoveItem('voucherInfo')
        history.goBack()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      setIsShowConfirmDelete(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveInstallmentIncome(request, projectCode, periodInfo?.periodNumber)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setRequest()
        setIsShowConfirm(false)
        setTimeout(() => {
          if (voucherInfo?.id) {
            location.reload()
          } else {
            history.goBack()
          }
        }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || DEFAULT_ERR_MSG)
      } else {
        setIsError(DEFAULT_ERR_MSG)
      }
      setIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const formData = new FormData()

    formData.append('Id', voucherInfo?.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('PeriodId', periodInfo?.id || '')
    formData.append('VoucherNumber', data.voucherNumber || '')
    formData.append('ReferenceNumber', data.referenceNumber || '')
    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('AccountChannelConfirm', data.accountChannelConfirm || '')
    formData.append('BankAccount', data.bankAccount || '')
    formData.append('BankAccountConfirm', data.bankAccountConfirm || '')
    formData.append('VoucherDate', moment(data.voucherDate).format('YYYY/MM/DD') || '')
    formData.append('Description', data.description || '')
    formData.append('ReceiveMoneyEtc', data.receiveMoneyEtc || '')

    formData.append('IsDraft', false)

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    const formTable = data.table?.filter((i) => !i.isRowTotal) || []
    console.log('formTable', formTable)

    if (formTable.length > 0) {
      formTable?.forEach((item, index) => {
        formData.set(`FormTable[${index}].IncomeType`, item.incomeType || '')
        formData.set(`FormTable[${index}].SubProjectCode`, item.subProjectCode || '')
        formData.set(`FormTable[${index}].BankAccount`, item.bankAccount || '')
        formData.set(`FormTable[${index}].Amount`, item.amount || 0)
        formData.set(`FormTable[${index}].Vat`, item.vat || 0)
        formData.set(`FormTable[${index}].Withholding`, item.withholding || 0)
        formData.set(`FormTable[${index}].ReceivedAmount`, item.receivedAmount || 0)
        formData.set(`FormTable[${index}].Id`, item.id?.indexOf('addNew') != -1 ? '' : item.id)
        formData.set(
          `FormTable[${index}].AttachReceipt`,
          item.attachReceipt ? item.attachReceipt[0]?.blobFile : null
        )
        formData.set(
          `FormTable[${index}].IsDeleteAttachReceipt`,
          item.isDeleteAttachReceipt || false
        )
      })
    } else {
      notification.open('error', {
        title: 'กรุณาเพิ่มรายการบันทึกรับ อย่างน้อย 1 รายการ',
      })
      return
    }

    setRequest(formData)

    setIsShowConfirm(true)
  }
  const DraftOnSumit = () => {
    const data = getValues()

    console.log('draft data', data)

    const formData = new FormData()

    formData.append('Id', voucherInfo?.id || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('PeriodId', periodInfo?.id || '')
    formData.append('VoucherNumber', data.voucherNumber || '')
    formData.append('ReferenceNumber', data.referenceNumber || '')
    formData.append('AccountChannel', data.accountChannel || '')
    formData.append('AccountChannelConfirm', data.accountChannelConfirm || '')
    formData.append('BankAccount', data.bankAccount || '')
    formData.append('BankAccountConfirm', data.bankAccountConfirm || '')

    formData.append(
      'VoucherDate',
      data.voucherDate ? moment(data.voucherDate).format('YYYY/MM/DD') : ''
    )

    formData.append('Description', data.description || '')
    formData.append('ReceiveMoneyEtc', data.receiveMoneyEtc || '')

    formData.append('IsDraft', true)

    if (Array.isArray(data.attachFiles)) {
      data.attachFiles.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })
    }

    if (Array.isArray(data.deleteFileIds)) {
      data.deleteFileIds.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })
    }

    const formTable = data.table?.filter((item) => !item.isRowTotal) || []

    if (formTable.length > 0) {
      formTable.forEach((item, index) => {
        formData.set(`FormTable[${index}].IncomeType`, item.incomeType || '')
        formData.set(`FormTable[${index}].SubProjectCode`, item.subProjectCode || '')
        formData.set(`FormTable[${index}].BankAccount`, item.bankAccount || '')
        formData.set(`FormTable[${index}].Amount`, item.amount || 0)
        formData.set(`FormTable[${index}].Vat`, item.vat || 0)
        formData.set(`FormTable[${index}].Withholding`, item.withholding || 0)
        formData.set(`FormTable[${index}].ReceivedAmount`, item.receivedAmount || 0)

        formData.set(
          `FormTable[${index}].Id`,
          item.id?.indexOf('addNew') !== -1 ? '' : item.id || ''
        )

        if (item.attachReceipt?.length > 0) {
          formData.set(`FormTable[${index}].AttachReceipt`, item.attachReceipt[0]?.blobFile)
        }

        formData.set(
          `FormTable[${index}].IsDeleteAttachReceipt`,
          item.isDeleteAttachReceipt || false
        )
      })
    }

    setRequest(formData)
    setIsShowConfirm(true)
  }
  const onPreview = async (id, fileName) => {
    startLoading()
    try {
      var file = await downloadRecieptVoucherFile(id)

      previewFile(file, 'ใบสำคัญรับ ' + fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {!isViewOnly && !formSchema?.disabled ? (
          <>
            <IncomeRecordForm
              schema={formSchema?.form}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
              setIsEnableEdit={setIsEnableEdit}
            />
          </>
        ) : (
          <>
            <IncomeRecordView schema={formSchema?.form} isViewMode={formSchema?.disabled} />
          </>
        )}

        <IncomeRecordTable
          schema={formSchema?.form?.formTable}
          loading={isLoading}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          isReceiveAnnuity={formSchema?.form?.isReceiveAnnuity}
          isEnableEdit={isEnableEdit}
          isViewMode={isViewOnly || formSchema?.disabled}
          bankAccount={formSchema?.form?.bankAccount}
          isAddDisabled={formSchema?.form?.isAddDisabled}
        />

        <div>
          <br />
          <Row>
            {isError && <Message showIcon type="error" description={isError} />}
            <Col lg={12} md={12} sm={24} xs={24}>
              {!isViewOnly && !formSchema?.disabled && (
                <Button
                  color="red"
                  appearance="link"
                  onClick={() => setIsShowConfirmDelete(true)}
                  disabled={
                    isLoading ||
                    formSchema?.form?.isReceiveAnnuity ||
                    !voucherInfo?.id ||
                    formSchema?.form?.isDeleteDisabled
                  }
                >
                  <Icon icon="trash" size="lg" /> ลบเอกสาร
                </Button>
              )}
            </Col>
            <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <Button
                color="blue"
                appearance="link"
                disabled={formSchema?.form?.enableSaveDraft || !voucherInfo?.id}
                onClick={() => {
                  onPreview(voucherInfo?.id, voucherInfo?.voucherNumber)
                }}
              >
                <Icon icon="eye" size="lg" /> ดูใบสำคัญรับ
              </Button>
              {!isViewOnly && !formSchema?.disabled && (
                <>
                  {formSchema?.form?.enableSaveDraft && (
                    <SaveButton
                      disabled={isLoading || formSchema?.form?.isEditDisabled}
                      onClick={DraftOnSumit}
                    >
                      บันทึกร่าง
                    </SaveButton>
                  )}

                  <SaveButton
                    disabled={isLoading || formSchema?.form?.isEditDisabled}
                    onClick={handleSubmit(onSubmit)}
                  >
                    บันทึก
                  </SaveButton>
                  <CancelButton
                    onClick={() => {
                      history.goBack()
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={'ยืนยันการบันทึก'}
        show={isShowConfirm}
        //detail={'ยืนยันการบันทึก'}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={'ยืนยันลบเอกสาร'}
        show={isShowConfirmDelete}
        //detail={'ยืนยันลบเอกสาร'}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCallDelete}
      />
    </>
  )
}
